import apiClient from '../client';
import {AsyncResult, err, ok} from '../../../utils/result';
import type {Playlist} from '../types';

// @ts-ignore
export const fetchPlaylist = async (playlistId: string): AsyncResult<Playlist> => {
    try {
        const response = await apiClient.get('media', {params: {id: playlistId}});
        return ok(response.data as Playlist);
    } catch (error) {
        return err(`Failed to fetch playlist with id ${playlistId}`);
    }
};
